import Product, { FeatureId } from '../../Model/Product';
import User from '../../Model/User';

/**
 * Whether chat is enabled for a client — the union across every product they hold, so
 * a product with chat off cannot silence one that has it on. Defaults to enabled when
 * nothing resolves, matching the rest of the feature checks.
 *
 * @param {string} userId - The client whose chat access to resolve.
 * @param {string} [coachId] - The coach the question is scoped to.
 * @return {Promise<boolean>}
 */
const isChatEnabled = async (userId, coachId) => {
  // The channel view asks before a conversation is selected, so there is often no client yet.
  if (!userId) {
    return true;
  }
  const userDoc = await User.getById(userId, { viewAsCoachId: coachId });
  if (!userDoc) {
    return true;
  }
  const products = await Promise.all(
    userDoc.featureProductIds.map((productId) => Product.getById(productId)),
  );
  return Product.isFeatureAvailable(products.filter(Boolean), FeatureId.CHAT);
};

export {
  isChatEnabled,
};
